(function () {
    "use strict";

    angular
        .module("app")
        .directive("productHierarchySearchHelp", ["SearchFactory", productHierarchySearchHelp]);

    function productHierarchySearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.productHierarchyKey = "";
                        scope.productHierarchyName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.productHierarchyName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.productHierarchySearch(scope.sapBrandId, function (productHierarchy) {
                        scope.productHierarchyKey = productHierarchy ? productHierarchy.ProductHierarchyKey : "";
                        scope.productHierarchyName = productHierarchy ? productHierarchy.ProductHierarchyName : "";
                        scope.displayValue = scope.productHierarchyName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.displayValue = scope.productHierarchyName;
                scope.prevDisplayValue = scope.displayValue;


                scope.$watch("productHierarchyName", function (newValue) {
                    scope.displayValue = newValue;
                });
            },
            scope: { productHierarchyKey: "=", productHierarchyName: "=", readOnly: "=", required: "=", controlName: "@", sapBrandId: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

